import React, {Component} from 'react';
import {FormSectionHeader} from "../../public/FormSectionHeader";
import IntakeFormTextEnum from "../enum/IntakeFormTextEnum";
import {FormLine} from "../../public/FormLine";
import FormField from "../../../../components/form/FormField";
import {FormPhoneInput} from "../../public/FormPhoneInput";
import {YesNoRadioInput} from "../../public/YesNoRadioInput";
import {Dropdown} from "primereact/dropdown";

class PublicIntakeFormContactInformation extends Component {
    render() {
        const {
            selectedLanguage, enumLabel, nationalityLabel, form, onChange, nationalities,
            textField, formFields
        } = this.props;

        return (
            <>
                <FormSectionHeader header={IntakeFormTextEnum.Contact_Information[selectedLanguage]}/>
                <FormLine label={IntakeFormTextEnum.Phone_Number[selectedLanguage]}>
                    <FormField
                        ref={(ref) => formFields.push(ref)}
                        required
                        validateOn={form.contactMobilePhone}
                    >
                        <FormPhoneInput
                            value={form.contactMobilePhone}
                            onValueChange={(value) =>
                                onChange("contactMobilePhone", value)
                            }
                        />
                    </FormField>
                </FormLine>
                <div className="row form-group">
                    <label className="col-6 col-form-label">
                        {IntakeFormTextEnum.Do_You_Use_This_Number_For_Whatsapp[selectedLanguage]}
                    </label>
                    <div className="col d-flex justify-content-end">
                            <YesNoRadioInput
                                value={form.doYouUseThisNumberForWhatsapp}
                                onValueChange={(value) => {
                                    if ("Yes" === value) {
                                        form.contactOtherPhone = "";
                                    }
                                    onChange("doYouUseThisNumberForWhatsapp", value);
                                }}
                                enumLabel={enumLabel}
                            />
                    </div>
                </div>
                {"No" === form.doYouUseThisNumberForWhatsapp && (
                    <FormLine label={IntakeFormTextEnum.Other_Phone[selectedLanguage]}>
                        <FormPhoneInput
                            value={form.contactOtherPhone}
                            onValueChange={(value) =>
                                onChange("contactOtherPhone", value)
                            }
                        />
                    </FormLine>
                )}
                <FormLine label={IntakeFormTextEnum.Email[selectedLanguage]}>
                    {textField(form, "contactEmail")}
                </FormLine>
                <FormLine
                    label={IntakeFormTextEnum.Address[selectedLanguage]}>{textField(form, "address")}</FormLine>
                <FormLine label={IntakeFormTextEnum.Country[selectedLanguage]}>
                    <Dropdown
                        className="DropdownBorderColor w-100"
                        value={form.country}
                        dataKey={"code"}
                        options={nationalities}
                        optionLabel={nationalityLabel}
                        filter
                        filterLocale={"en-US"}
                        filterBy={nationalityLabel}
                        onChange={(event) =>
                            onChange("country", event.value)
                        }
                    />
                </FormLine>
                <FormLine label={IntakeFormTextEnum.City[selectedLanguage]}>
                    {textField(form, "city")}
                </FormLine>
                <FormLine label={IntakeFormTextEnum.Postal_Code[selectedLanguage]}>
                    {textField(form, "postalCode")}
                </FormLine>
            </>
        );
    }
}

export default PublicIntakeFormContactInformation;